import { AccountCallout } from 'components/accounts/AccountCallout'
import { AccountContactInformation } from 'components/accounts/AccountContactInformation'
import { AccountDetails } from 'components/accounts/AccountDetails'
import { AccountEntities } from 'components/accounts/AccountEntities'
import { AccountHeader } from 'components/accounts/AccountHeader'
import { AccountOpportunities } from 'components/accounts/AccountOpportunities'
import { AccountSidebar } from 'components/accounts/AccountSidebar'
import { InvestorDetails } from 'components/accounts/InvestorDetails'
import { LatestHoldings } from 'components/holdings/LatestHoldings'
import { LatestOpportunities } from 'components/opportunities/LatestOpportunities'
import { Masonry, RouterTabContent, RouterTabs, useRouter, useSidebar } from '@forgeglobal/design-framework'
import { Relationships } from 'components/accounts/AccountConnections'
import { Routes } from 'util/Routes'
import { ShareHolderSection } from 'components/accounts/ShareholderDetails'
import { useBaseAccountQuery } from 'graphql/bindings/AdminBindings'
import Documents from 'components/shared/Documents'
import React, { Fragment, useEffect } from 'react'

export const Account: React.FC = () => {
  const { match, history } = useRouter<{ id: string }>()
  const accountId = match.params.id
  const { data, loading } = useBaseAccountQuery({ variables: { id: accountId } })
  const [expanded, setExpanded] = React.useState<string>('conversations')
  const isInvestor = data?.account?.is_investor ?? false
  const isShareholder = data?.account?.is_shareholder ?? false
  const accountType = data?.account?.type
  const numOpportunities = data?.account.opportunities.length ?? 0

  useEffect(() => {
    if (accountType === 'issuer') {
      history.replace(Routes.issuer(accountId))
    }
  }, [accountType, accountId, history, numOpportunities])

  const { showSidebar } = useSidebar(
    <AccountSidebar accountId={accountId} expanded={expanded} setExpanded={setExpanded} />,
    [expanded, setExpanded, accountId]
  )

  const openSidebarSection = (name: string) => {
    showSidebar() // forces open on mobile
    setExpanded(name)
  }
  const openOpportunitiesSidebar = () => {
    openSidebarSection('trade')
  }
  const openHoldingsSidebar = () => {
    openSidebarSection('portfolio')
  }

  const sections = [
    <AccountDetails key="accountdetails" />,
    <AccountContactInformation accountId={accountId} key="info" />,
    isInvestor && <InvestorDetails key="investordetails" />,
    isShareholder && <ShareHolderSection key="shareholderdetails" />,
    <LatestOpportunities key="latestopps" openSidebar={openOpportunitiesSidebar} />,
    <LatestHoldings key="latestholdings" openSidebar={openHoldingsSidebar} />,
    <Relationships key="relationships" />,
    <AccountEntities key="entities" accountId={accountId} />,
    <Documents key="documents" accountId={accountId} />,
  ].filter(e => !!e)

  return (
    <Fragment>
      <AccountHeader />
      {!loading && (
        <Fragment>
          <AccountCallout />

          {accountType === 'issuer' && <Masonry items={sections} />}

          {accountType !== 'issuer' && (
            <RouterTabs>
              <RouterTabContent label="account details">
                <Masonry items={sections} />
              </RouterTabContent>
              <RouterTabContent label="opportunities">
                <AccountOpportunities accountId={accountId} />
              </RouterTabContent>
            </RouterTabs>
          )}
        </Fragment>
      )}
    </Fragment>
  )
}
